import React from "react";
import { Link } from "react-router-dom";
import type { ISpread } from "../../api/spreadsSlice";
import "./spread.css";

interface SpreadCardProps {
  spread: ISpread;
  to: string;
}

export const SpreadCard:
  React.FC<
    SpreadCardProps
  > = ({
    spread,
    to,
  }) => {
    const {
      id,
      name,
      altNames,
      purpose,
      cardsCount,
      positions,
      symbolism,
      archetypes,
      psychology,
    } = spread;

    return (
      <article
        className="spread-card"
        data-spread-id={id}
      >
        <header className="spread-card__header">
          <div className="spread-card__meta">
            <span>
              Карт: {cardsCount}
            </span>

            <span>
              Позиций:{" "}
              {positions.length}
            </span>
          </div>

          <h3 className="spread-card__title">
            {name}
          </h3>

          {altNames?.length ? (
            <div className="spread-card__alt">
              {altNames.join(
                " / "
              )}
            </div>
          ) : null}
        </header>

        <p className="spread-card__purpose">
          {purpose}
        </p>

        <details className="spread-card__details">
          <summary>
            Подробнее о раскладе
          </summary>

          <div className="spread-card__details-body">
            {positions.length >
            0 ? (
              <section className="spread-card__section">
                <div className="spread-card__label">
                  Позиции
                </div>

                <ol className="spread-card__positions">
                  {positions.map(
                    (
                      position
                    ) => (
                      <li
                        key={
                          position.id
                        }
                      >
                        <strong>
                          {
                            position.title
                          }
                        </strong>

                        <span>
                          {
                            position.meaning
                          }
                        </span>
                      </li>
                    )
                  )}
                </ol>
              </section>
            ) : null}

            {symbolism ? (
              <section className="spread-card__section">
                <div className="spread-card__label">
                  Символика
                </div>

                <p>
                  {symbolism}
                </p>
              </section>
            ) : null}

            {archetypes?.length ? (
              <section className="spread-card__section">
                <div className="spread-card__label">
                  Архетипы
                </div>

                <div className="spread-card__tags">
                  {archetypes.map(
                    (
                      archetype
                    ) => (
                      <span
                        key={
                          archetype
                        }
                      >
                        {
                          archetype
                        }
                      </span>
                    )
                  )}
                </div>
              </section>
            ) : null}

            {psychology ? (
              <section className="spread-card__section">
                <div className="spread-card__label">
                  Психология
                </div>

                <p>
                  {psychology}
                </p>
              </section>
            ) : null}
          </div>
        </details>

        <footer className="spread-card__footer">
          <Link
            to={to}
            className="spread-card__link"
          >
            Открыть расклад
            <span aria-hidden="true">
              →
            </span>
          </Link>
        </footer>
      </article>
    );
  };

